import React from 'react'
import ExportMenuItemBase from './ExportMenuItemBase'
import {Area} from 'organization/Event/AreasProvider'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {useGet} from 'lib/requests'

export default function ExportAttendeesDetailedMenuItem(props: {
  area: Area
  setError: (error: string | null) => void
  setSuccess: (success: string | null) => void
}) {
  const {exportLog, processing, errorMessage, successMessage} = useExportLog(
    props.area,
    false,
  )

  return (
    <ExportMenuItemBase
      ref={null}
      label="Export Detail Log"
      ariaLabel="export detail log"
      area={props.area}
      onExport={exportLog}
      processing={processing}
      errorMessage={errorMessage}
      successMessage={successMessage}
      setError={props.setError}
      setSuccess={props.setSuccess}
    />
  )
}
function useExportLog(area: Area, isSummary?: boolean) {
  const {event} = useEvent()
  const exportMode = isSummary ? 'summary' : 'detail'
  const url = api(
    `/events/${event.id}/areas/${area.id}/attendees/export?exportMode=${exportMode}`,
  )
  const {client} = useOrganization()

  const {send: exportLog, processing, errorMessage, successMessage} = useGet(
    client,
    url,
  )

  return {
    exportLog,
    processing,
    errorMessage,
    successMessage,
  }
}
